import { ENV, removeIdFromLocalStorage, removeJsonFromLocalStorage } from "../../../utils";
import documentTypes from '../../../utils/documentTypes';
import hotelTypes from '../../../utils/hotelTypes';
import { Form, Button, Image } from 'semantic-ui-react';
import { getEducationDebt, getDebt, getOperaDebts } from '../../../api/deudas';
import productTypes from '../../../utils/productTypes';
import React, { useState, useEffect } from 'react';
import HCaptcha from '@hcaptcha/react-hcaptcha';
import Alert from '../../Shared/Alert/Alert'
import { image } from "../../../assets";
import "./StepOne.scss";

function StepOne({ nextStep, setLoading }) {

  removeIdFromLocalStorage();
  removeJsonFromLocalStorage();

  const termsText = ENV.TEXT.TERMS_LABEL_PART1;
  const policyText = ENV.TEXT.TERMS_LABEL_PART2;
  const authorizationText = ENV.TEXT.TERMS_LABEL_PART3;
  const privacyText = ENV.TEXT.TERMS_LABEL_PART4;
  const rightText = ENV.TEXT.TERMS_LABEL_PART5;

  const policyUrl =  ENV.TEXT.POLICY_URL;
  const authorizationUrl =  ENV.TEXT.AUTHORIZATION_URL;
  const privacyUrl =  ENV.TEXT.PRIVACY_URL;
  const rightUrl =  ENV.TEXT.RIGHT_URL;
  
  const [formData, setFormData] = useState({
    hotelType: hotelTypes[0].value,
    documentType: documentTypes[0].value,
    productType: '',
    documentNumber: '',
    invoice: '',
    termsAccepted: false,
  });

  const [error, setError] = useState(null);
  const [invoiceError, setInvoiceError] = useState(null);
  const [alertType, setAlertType] = useState(null);
  const [isFormValid, setIsFormValid] = useState(false);
  const [docNumberError, setDocNumberError] = useState(null);
  const [captchaToken, setCaptchaToken] = useState(null);
  const [isEducationCredit, setIsEducationCredit] = useState(false);
  const [showHotelSelect, setShowHotelSelect] = useState(false);

  const [documentNumberPlaceHolder, setDocumentNumberPlaceHolder] = useState("Ej.: 1010599090");
  const [filteredDocumentTypes, setFilteredDocumentTypes] = useState(documentTypes);
  const [invoicePlaceHolder, setInvoicePlaceHolder] = useState("Ej.: 1000980909090");
  const [invoiceLabel, setInvoiceLabel] = useState("Número de obligación / Referencia"); 
  const [documentNumberMsj, setDocumentNumberMsj] = useState(null); 
  const [invoiceMsj, setInvoiceMsj] = useState(null);
  const [maxLengthDocument, setMaxLengthDocument] = useState(20);

  useEffect(() => {
    const isValid =
      formData.hotelType &&
      formData.documentType &&
      formData.productType &&
      formData.documentNumber &&
      formData.invoice &&
      formData.termsAccepted &&
      captchaToken &&
      !docNumberError &&
      !invoiceError;
    setIsFormValid(isValid);
  }, [formData, docNumberError, invoiceError, captchaToken]);

  const handleChange = (e, { name, value }) => {

    setFormData({ ...formData, [name]: value });

    if (name === 'documentType') {
      if (value === 'NIT') {
        setDocumentNumberPlaceHolder("Ej.: 800908900");
        setDocumentNumberMsj("Ingresa el NIT sin dígito de verificación");
      } else {
        setDocumentNumberPlaceHolder("Ej.: 1010599090");
        setDocumentNumberMsj(null);
      }
    }

    if (name === 'productType') {

      if (value === '1') {
        setIsEducationCredit(true);
      } else {
        setIsEducationCredit(false);
      }
      if (value === '3') {
        setInvoicePlaceHolder("Ej.: 502397");
        setInvoiceLabel("Número Tarjeta multiservicios");
        setInvoiceMsj("Ingresa los últimos cinco dígitos de la tarjeta");
        setMaxLengthDocument(5);
        setShowHotelSelect(false);
      } else if (value === '10') {
        setInvoicePlaceHolder("Ej.: 328381153");
        setInvoiceLabel("Número de reserva");
        setInvoiceMsj(null);
        setMaxLengthDocument(20);
        setShowHotelSelect(true);
      } else {
        setInvoicePlaceHolder("Ej.: 1000980909090");
        setInvoiceLabel("Número de obligación / Referencia");
        setInvoiceMsj(null);
        setMaxLengthDocument(20);
        setShowHotelSelect(false);
      }
    }
  

    if (name === 'documentNumber') {
      const numberAndLetterRegex = /^[0-9a-zA-Z]*$/;
      if (!numberAndLetterRegex.test(value)) {
        setDocNumberError("Este campo solamente permite números y letras (sin caracteres especiales).");
        setIsFormValid(false);
      } else if (value.length > 10) {
        setDocNumberError("Máximo 10 caracteres");
        setIsFormValid(false);
      } else if (value === '') {
        setDocNumberError("Este campo es obligatorio");
        setIsFormValid(false);
      } else {
        setDocNumberError(null);
        setIsFormValid(true);
      }
    }

    if (name === 'invoice') {
      const numberRegex = /^[0-9]*$/;
      if (!numberRegex.test(value)) {
        setInvoiceError("Este campo solamente permite números.");
        setIsFormValid(false);
      } else if (value.length > maxLengthDocument) {
        setInvoiceError("Máximo " + maxLengthDocument + " dígitos");
        setIsFormValid(false);
      } else if (value === '') {
        setInvoiceError("Este campo es obligatorio");
        setIsFormValid(false);
      } else if (formData.productType === '3' && value.length < 5) {
        setInvoiceError("Debes ingresar mínimo 5 dígitos");
      }  else {
        setInvoiceError(null);
      }
    }

  };


  useEffect(() => {
    if (formData.invoice && formData.invoice.length > maxLengthDocument) {
      setInvoiceError(`Máximo ${maxLengthDocument} dígitos`);
    } else if (formData.productType === '3' && formData.invoice && formData.invoice.length < 5) {
      setInvoiceError("Debes ingresar mínimo 5 dígitos");
    } else {
      setInvoiceError(null);
    }
  }, [maxLengthDocument, formData.invoice, formData.productType]);



  useEffect(() => {

    let updatedDocumentTypes = [...documentTypes];

    if (formData.documentType === "NIT") {
      setDocumentNumberPlaceHolder("Ej.: 800908900");
      setDocumentNumberMsj("Ingresa el NIT sin dígito de verificación");
      console.log("ingresó: *********");
    }

    if (formData.productType === '1') {
      updatedDocumentTypes = documentTypes.filter(doc => doc.value !== "NIT");
      setDocumentNumberPlaceHolder("Ej.: 1010599090");
      setDocumentNumberMsj(null);
    } else if (formData.productType === "10") {
      setDocumentNumberPlaceHolder("Ej.: 1010599090");
      setDocumentNumberMsj(null);
      updatedDocumentTypes = documentTypes
      .filter(doc => doc.value !== "NIT" && doc.value !== "PEP" && doc.value !== "TI") 
      .concat({ key: "PA", value: "PA", text: "Pasaporte" });
    }

    setFilteredDocumentTypes(updatedDocumentTypes);
    
   

  }, [formData.productType, formData.documentType, formData.documentNumber]);


  const handleSubmit = async () => {
    if (!isFormValid) return; 
    setLoading(true);
    setError(null);

    try {

      let data = null;

      if (isEducationCredit) {
        data = await getEducationDebt(formData.documentType, formData.documentNumber, formData.invoice);
      } else if (formData.productType === '10') {
        data = await getOperaDebts(formData.documentType, formData.documentNumber, formData.invoice, getHotelByKey(formData.hotelType), formData.hotelType);
      } else {
        data = await getDebt(formData.documentType, formData.documentNumber, formData.invoice, formData.productType);
      }
      
      if (data.message === ENV.TEXT.BACK_ERROR_RESPONSE) {
        setError(ENV.TEXT.ERROR_ALERT_DEBTS);
        setAlertType('blue');
      } else if (data.code === '500') {
        setError(ENV.TEXT.ERROR_ALERT_SERVER);
        setAlertType('red');
      } else if (data.body.length === 0) {
        setAlertType('blue');
        setError(ENV.TEXT.ERROR_ALERT_DEBTS);
      } else {
        nextStep({ ...formData, debts: data.body });
      }
    } catch (err) {
      setError(ENV.TEXT.BACK_ERROR_RESPONSE);
      setAlertType('red');
    } finally {
      setLoading(false);
      setIsFormValid(true);
    }
  };

  const handleCaptchaVerification = (token) => {
    setCaptchaToken(token); 
  };
  const handleCaptchaError = () => {
    setCaptchaToken(null); 
  };
  const handleCaptchaExpire = () => {
    setCaptchaToken(null); 
  };

  const getHotelByKey = (value) => {
    return hotelTypes.find(hotel => hotel.value === value);
  };


  return (
    <div className="steps-container">
          <div className="steps-title"><strong>Paso 1 de 4:</strong> Información del pagador</div>
          
          {error && <Alert errorMessage={error} styleType={alertType} />}

          <p className="steps-text-big-out">Ingresa tus datos</p>
          <p className="steps-text-out">Podrás realizar tus pagos de forma sencilla a través de PSE</p>

          <div className="steps-card-box">
            <div className="steps-card-content">
              <div className="steps-card">
                <p className="steps-text-big">Ingresa tus datos</p>
                <p className="steps-text">Podrás realizar tus pagos de forma sencilla a través de PSE</p>

                <Form onSubmit={handleSubmit} id="ingresar_datos">

                <Form.Select
                    id="tipo_producto"
                    label="Tipo de producto"
                    name="productType"
                    options={productTypes}
                    placeholder="Selecciona una opción"
                    onChange={handleChange}
                    required
                    className="steps-dropdown"
                  />

                  <Form.Select
                    id="tipo_documento"
                    label="Tipo de documento"
                    name="documentType"
                    options={filteredDocumentTypes}
                    placeholder={documentTypes[0].text}
                    onChange={handleChange}
                    required
                    defaultValue={documentTypes[0].value}
                    className="steps-dropdown"
                  />

                  <Form.Input
                    id="num_documento"
                    className={docNumberError ? 'err-input' : 'info-document'}
                    label="Número de documento"
                    name="documentNumber"
                    placeholder={documentNumberPlaceHolder}
                    onChange={handleChange}
                    required
                    error={!!docNumberError}
                    type="text"
                    onPaste={(event) => event.preventDefault()}
                    onDrop={(event) => event.preventDefault()}
                  />
                  {documentNumberMsj && <div className="error-label-left">{documentNumberMsj}</div>}
                  {docNumberError && <div className="error-label">{docNumberError}</div>}                  

                  <Form.Input
                    id="invoice"
                    className={invoiceError ? 'err-input-up' : 'info-invoice'}
                    label={invoiceLabel}
                    placeholder={invoicePlaceHolder}
                    name="invoice"
                    onChange={handleChange}
                    required
                    error={!!invoiceError}
                    type="number"
                    onPaste={(event) => event.preventDefault()}
                    onDrop={(event) => event.preventDefault()}
                  />
                  {invoiceMsj && <div className="error-label-left">{invoiceMsj}</div>}
                  {invoiceError && <div className="error-label">{invoiceError}</div>}

                  {showHotelSelect && (
                    <Form.Select
                      id="tipo_hotel"
                      label="Seleccione el hotel"
                      name="hotelType"
                      options={hotelTypes}
                      placeholder={hotelTypes[0].text}
                      onChange={handleChange}
                      required
                      defaultValue={hotelTypes[0].value}
                      className="info-invoice"
                    />
                  )}

                  <div className="checkbox-container">
                    <div className="checkbox-wrapper">
                    <Form.Checkbox
                      id="acepta_terminos"
                      name="termsAccepted"
                      onChange={(e, { checked }) => setFormData({ ...formData, termsAccepted: checked })}
                      required
                    />
                    </div>
                    <div className="checkbox-text">
                      <span>{termsText}</span>
                      <a href={policyUrl} target="_blank" rel="noopener noreferrer">
                        {policyText}
                      </a>, 
                      <a href={authorizationUrl} target="_blank" rel="noopener noreferrer">
                        {authorizationText}
                      </a>, 
                      <a href={privacyUrl} target="_blank" rel="noopener noreferrer">
                        {privacyText}
                      </a> y 
                      <a href={rightUrl} target="_blank" rel="noopener noreferrer">
                        {rightText}
                      </a>.
                    </div>
                  </div>

                  <HCaptcha
                    id="h_captcha"
                    sitekey="1c97112a-45ca-4b71-b3f4-d5a771914e45"                    
                    onVerify={handleCaptchaVerification}
                    onError={handleCaptchaError}
                    onExpire={handleCaptchaExpire}/>

                  <Button id="continuar" type="submit"  disabled={!isFormValid} style={{ marginTop: '16px' }}>
                    Continuar
                  </Button>
                </Form>
              </div>
            </div>
          </div>

          <div className="feet">
            <a href={ENV.BASE_BOX} className="exit_text">
              Salir
            </a>
            <a href={ENV.BASE_BOX} className="exit_icon">
              <Image src={image.logOut} />
            </a>
          </div>
    </div>
  );
}

export default StepOne;
